import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations();

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class HeroHeaderModel extends Model.extend(Validations) {
  @attr('number', { defaultValue: 0 }) alignment;
  @attr('string') buttonText;
  @attr('boolean') hideButton;
  @attr('string') text;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) logo;
}
